export const SET_ACTION_MESSAGE = 'SET_ACTION_MESSAGE';
export const SET_MOBILE_MENU_VISIBILITY = 'SET_MOBILE_MENU_VISIBILITY';
export const SET_COOKIE_MODAL_VISIBILITY = 'SET_COOKIE_MODAL_VISIBILITY';
export const SET_COOKIE_SETTINGS = 'SET_COOKIE_SETTINGS';
export const ADD_TO_OVERLAY_STACK = 'ADD_TO_OVERLAY_STACK';
export const REMOVE_FROM_OVERLAY_STACK = 'REMOVE_FROM_OVERLAY_STACK';
export const SET_CHANGED_MY_SHEETS = 'SET_CHANGED_MY_SHEETS';
export const SET_COUNTRY_LIST = 'SET_COUNTRY_LIST';
